<template>
  <div class="selector-box">
    <div class="selector-upload">
      <img
        v-if="imageUrl || imagePath"
        :src="imageUrl || imagePath"
        class="selector-image"
        :class="clickable === 0 ? 'upload-pointer-no' : 'upload-pointer'"
        @click="onPreview"
      >
      <el-upload
        v-else
        action=""
        :show-file-list="false"
        :auto-upload="false"
        :on-change="onChange"
        :disabled="clickable === 0"
      >
        <div
          class="selector-tip"
          :class="clickable === 0 ? 'upload-pointer-no' : 'upload-pointer'"
        >
          <i class="el-icon-plus" />
          <div slot="tip">点击上传{{ tip }}</div>
        </div>
      </el-upload>
    </div>
    <img
      v-show="clickable === 1 && (imageUrl || imagePath)"
      src="@/assets/imgs/login/image-delete.png"
      class="selector-delete"
      :class="clickable === 0 ? 'upload-pointer-no' : 'upload-pointer'"
      @click="onDelete"
    >
    <el-dialog :visible.sync="dialogVisible" :modal-append-to-body="false">
      <img width="100%" :src="imageUrl || imagePath">
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ImageSelector',
  props: {
    tip: {
      type: String,
      default: ''
    },
    // 0否1是
    clickable: {
      type: Number,
      default: 0
    },
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      imagePath: '',
      imageUrl: this.url,
      dialogVisible: false,
      fileSrc: null
    }
  },
  methods: {
    onChange(file) {
      console.log(file)
      const types = ['image/jpeg', 'image/jpg', 'image/png']
      const isImage = types.includes(file.raw.type)
      const isLtSize = file.raw.size / 1024 / 1024 < 3
      if (!isImage) {
        this.$message.error('上传图片只支持JPG、PNG格式!')
        return
      }
      if (!isLtSize) {
        this.$message.error('上传图片大小不能超过3MB!')
        return
      }
      this.imagePath = URL.createObjectURL(file.raw)
      console.log(this.imagePath)
      this.fileSrc = file.raw
    },
    onPreview() {
      if (this.clickable === 1) {
        this.dialogVisible = true
      }
    },
    onDelete() {
      if (this.clickable === 1) {
        this.imagePath = ''
        this.fileSrc = null
        this.imageUrl = ''
      }
    },
    getFile() {
      if (this.imageUrl) {
        return this.imageUrl
      }
      return this.fileSrc
    }
  }
}
</script>

<style scoped>
.selector-box {
  position: relative;
}
.selector-upload {
  border: 1px dashed #d9d9d9;
  width: 163px;
  height: 107px;
  margin: 8px 8px 0 0;
}
.upload-pointer {
  cursor: pointer;
}
.upload-pointer-no {
  cursor: default;
}
.selector-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.selector-tip {
  width: 161px;
  height: 105px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  color: #999999;
}
.selector-tip i {
  margin-bottom: 10px;
  font-size: 20px;
}
.selector-tip div {
  font-size: 14px;
}
.selector-delete {
  width: 18px;
  height: 18px;
  top: 0;
  right: 0;
  position: absolute;
}
</style>
